class FeedbackUseCase {
    constructor(feedbackRepo) {
        this.feedbackRepo = feedbackRepo;
    }
    async sendFeedback(payload) {
        return await this.feedbackRepo.sendFeedback(payload);
    }
}
export default FeedbackUseCase;
